import { render, staticRenderFns } from "./newManagementStandardOfFranchiseeHZ.vue?vue&type=template&id=17137a75&scoped=true"
import script from "./newManagementStandardOfFranchiseeHZ.vue?vue&type=script&lang=js"
export * from "./newManagementStandardOfFranchiseeHZ.vue?vue&type=script&lang=js"
import style0 from "./newManagementStandardOfFranchiseeHZ.vue?vue&type=style&index=0&id=17137a75&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17137a75",
  null
  
)

export default component.exports